"use client";
import React, { useState, useEffect } from "react";
import Hero from "@/components/Hero";
import "./responsive.css";
import TrustedBy from "@/components/TrustedBy";
import MeetYourAgent from "@/components/MeetYourAgent";
import Metrics from "@/components/Metrics";
import Testimonials from "@/components/Testimonials";
import NewsletterCard from "@/components/NewsletterCard";
import Footer from "@/components/Footer";

export default function Home() {
  const [lang, setLang] = useState<'vn' | 'en'>('vn');

  useEffect(() => {
    const savedLang = localStorage.getItem('keeneye_lang') as 'vn' | 'en';
    if (savedLang) {
      setLang(savedLang);
    }
  }, []);

  const handleSetLang = (newLang: 'vn' | 'en') => {
    setLang(newLang);
    localStorage.setItem('keeneye_lang', newLang);
  };

  return (
    <main className="hero-wrapper black">
      <Hero lang={lang} setLang={handleSetLang} />
      <TrustedBy lang={lang} />
      <MeetYourAgent lang={lang} />
      <Metrics lang={lang} />
      <Testimonials lang={lang} />
      <NewsletterCard lang={lang} />
      <Footer lang={lang} />
    </main>
  );
}
